import { Suspense, lazy, createElement, type ComponentPropsWithoutRef, type ComponentType } from 'react';

// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = <C extends ComponentType<any>>(Component: C) => {
  const LoadableComponent = (props: ComponentPropsWithoutRef<C>) => (
    <Suspense fallback={<LoadingScreen />}>{createElement(Component, props as never)}</Suspense>
  );
  return LoadableComponent;
};

// ----------------------------------------------------------------------

// AUTHENTICATION
export const Login = Loadable(lazy(() => import('../pages/auth/Login')));

// DASHBOARD

// GENERAL
export const GeneralApp = Loadable(lazy(() => import('../pages/dashboard/GeneralApp')));

export const CheckPriceMonitor = Loadable(
  lazy(() => import('../pages/dashboard/check-price'))
);

export const Storages = Loadable(
  lazy(() => import('../pages/dashboard/dictionaries/storages'))
);

export const Accounts = Loadable(
  lazy(() => import('../pages/dashboard/dictionaries/accounts'))
);

export const TransactionArticles = Loadable(
  lazy(() => import('../pages/dashboard/dictionaries/transaction-articles'))
);

export const SourceOrders = Loadable(
  lazy(() => import('../pages/dashboard/dictionaries/source-orders'))
);

export const OzonSellerAccounts = Loadable(
  lazy(() => import('../pages/dashboard/ozon/seller-accounts'))
);

export const DeliveryServices = Loadable(
  lazy(() => import('../pages/dashboard/dictionaries/delivery-services'))
);

export const DocumentTemplates = Loadable(
  lazy(() => import('../pages/dashboard/dictionaries/document-templates'))
);

export const Product = Loadable(
  lazy(() => import('../pages/dashboard/dictionaries/products'))
);

export const ProductCategory = Loadable(
  lazy(() => import('../pages/dashboard/dictionaries/product-categories'))
);

export const ProductBrand = Loadable(
  lazy(() => import('../pages/dashboard/dictionaries/product-brands'))
);

export const I18nLang = Loadable(
  lazy(() => import('../pages/dashboard/administration/languages'))
);

export const I18nKeys = Loadable(
  lazy(() => import('../pages/dashboard/administration/translations'))
);

export const Groups = Loadable(
  lazy(() => import('../pages/dashboard/administration/groups'))
);

export const StorageDocuments = Loadable(
  lazy(() => import('../pages/dashboard/storage-documents'))
);

export const Transactions = Loadable(
  lazy(() => import('../pages/dashboard/transactions'))
);

export const StorageShipments = Loadable(
  lazy(() => import('../pages/dashboard/storage-shipments'))
);

export const Sales = Loadable(
  lazy(() => import('../pages/dashboard/sales'))
);

export const OzonPostings = Loadable(
  lazy(() => import('../pages/dashboard/ozon/postings'))
);
export const WbSellerAccounts = Loadable(
  lazy(() => import('../pages/dashboard/wb/seller-accounts'))
);
export const WbPostings = Loadable(
  lazy(() => import('../pages/dashboard/wb/postings'))
);
export const WbCatalogProducts = Loadable(
  lazy(() => import('../pages/dashboard/wb/catalog-products'))
);

export const AvitoSellerAccounts = Loadable(
  lazy(() => import('../pages/dashboard/avito/seller-accounts'))
);
export const AvitoPostings = Loadable(
  lazy(() => import('../pages/dashboard/avito/postings'))
);

export const Users = Loadable(
  lazy(() => import('../pages/dashboard/administration/users'))
);
export const UserAccounts = Loadable(lazy(() => import('../pages/dashboard/user/accounts')));

export const Sites = Loadable(
  lazy(() => import('../pages/dashboard/sites'))
);

export const SiteShop = Loadable(lazy(() => import('../pages/dashboard/sites/view/shop')));
export const SiteShopCategories = Loadable(lazy(() => import('../pages/dashboard/sites/view/shop/categories')));
export const SiteShopProducts = Loadable(lazy(() => import('../pages/dashboard/sites/view/shop/products')));
export const SiteShopPayments = Loadable(lazy(() => import('../pages/dashboard/sites/view/shop/payments')));
export const SiteShopDeliveries = Loadable(lazy(() => import('../pages/dashboard/sites/view/shop/deliveries')));
export const SiteNews = Loadable(lazy(() => import('../pages/dashboard/sites/view/news')));
 // eslint-disable-next-line import/extensions
export const SitePages = Loadable(lazy(() => import('../pages/dashboard/sites/view/pages')));

export const ProcurementSuppliers = Loadable(lazy(() => import('../pages/dashboard/procurement/suppliers')));
export const ProcurementRequests = Loadable(lazy(() => import('../pages/dashboard/procurement/requests')));
export const ProcurementContracts = Loadable(lazy(() => import('../pages/dashboard/procurement/contracts')));
export const ProcurementDeliveries = Loadable(lazy(() => import('../pages/dashboard/procurement/deliveries')));

// MAIN
export const HomePage = Loadable(lazy(() => import('../pages/Home')));
export const ComingSoon = Loadable(lazy(() => import('../pages/ComingSoon')));
export const Maintenance = Loadable(lazy(() => import('../pages/Maintenance')));
export const Page500 = Loadable(lazy(() => import('../pages/Page500')));
export const Page403 = Loadable(lazy(() => import('../pages/Page403')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
